<template>
  <div class="ai-preparation-container">
    <!-- 主内容区域 -->
    <div class="main-content">
      <!-- 顶部按钮组 -->
      <div class="button-group">
        <button v-for="button in mainButtons" :key="button.id" class="main-button" :class="{
          active: activeMainButton === button.id,
          external: button.type === 'external'
        }" @click="handleMainButtonClick(button.id, button.type, button.url)">
          {{ button.label }}
        </button>
      </div>

      <!-- 内容区域 -->
      <div class="content-area">
        <!-- 自媒体训练内容 -->
        <SelfMediaTraining v-if="activeMainButton === 'selfMedia'" :key="'selfMedia'" />

        <!-- 智能体官网训练内容 -->
        <AIAgentTraining v-else-if="activeMainButton === 'aiAgent'" :key="'aiAgent'" />

        <!-- 共享账号池内容 -->
        <AccountPoolManagement v-else-if="activeMainButton === 'accountPool'" :key="'accountPool'" />
      </div>
    </div>
  </div>
</template>

<script>
import SelfMediaTraining from '@/components/SelfMediaTraining.vue'
import AIAgentTraining from '@/components/AIAgentTraining.vue'
import AccountPoolManagement from '@/components/AccountPoolManagement.vue'

export default {
  name: 'AiAuth',
  components: {
    SelfMediaTraining,
    AIAgentTraining,
    AccountPoolManagement
  },
  data() {
    return {
      activeMainButton: 'selfMedia',

      // 主按钮配置 - 新增共享账号池
      mainButtons: [
        { id: 'selfMedia', label: '自媒体训练' },
        { id: 'aiAgent', label: '智能体官网训练' },
        { id: 'accountPool', label: '共享账号池' },
        { id: 'thirdPartyMedia', label: '第三方媒体', type: 'external', url: '/mediaapi/media_store.html' }
      ]
    }
  },
  methods: {
    handleMainButtonClick(buttonId, type, url) {
      if (type === 'external') {
        // 外部链接，在新标签页打开
        this.openExternalPage(url)
      } else {
        // 内部按钮，切换内容
        this.activeMainButton = buttonId
      }
    },

    openExternalPage(path) {
      // 获取当前运行域名
      const currentDomain = window.location.origin
      // 构建完整URL
      const fullUrl = `${currentDomain}${path}`
      // 在新标签页打开
      window.open(fullUrl, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.ai-preparation-container {
  padding: 24px;
  min-height: calc(100vh - 160px);
  background: transparent;
}

.main-content {
  background: hsla(0, 0%, 100%, .1);
  border-radius: 16px;
  padding: 24px;
  backdrop-filter: blur(10px);
}

.button-group {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.main-button {
  padding: 12px 24px;
  background: hsla(0, 0%, 100%, .1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #e0e6ff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #ff7048;
    border-color: #ff7048;
    transform: translateY(-2px);
  }

  &.active {
    background: #ff7048;
    border-color: #ff7048;
  }
}

.content-area {
  min-height: 500px;
}

// 响应式设计
@media (max-width: 768px) {
  .ai-preparation-container {
    padding: 16px;
  }

  .button-group {
    gap: 12px;

    .main-button {
      padding: 10px 20px;
      font-size: 13px;
    }
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 16px;
  }

  .button-group {
    justify-content: center;
  }
}

/* 在现有的CSS中添加 */
.main-button.external {
  background: linear-gradient(135deg, #ff7048 0%, #ff4081 100%);
  position: relative;
  padding-right: 40px;
}

.main-button.external::after {
  content: '↗';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
}
</style>